import { Location } from './location';
import { DateRange } from './date-range';
import { Travelers } from './travelers';
import { HotelName } from './hotel-name';
import { CheckboxGroup } from './checkbox-group';
import { RadioGroup } from './radio-group';
import { PopularFilter } from './popular-filter';
import { ButtonToggleGroupCheckbox } from './button-toggle-group';
import { Slider } from './slider';

export const fieldMap = {
  destination: Location,
  dateRange: DateRange,
  rooms: Travelers,
  sort: RadioGroup,
  hotelName: HotelName,
  deals: CheckboxGroup,
  star: ButtonToggleGroupCheckbox,
  price: CheckboxGroup,
  lodging: CheckboxGroup,
  amenities: CheckboxGroup,
  pricing: Slider, // Exp 28024: LShop_Show_Price_Slider_Filter
  regionId: RadioGroup, // neighborhood
  travelerType: CheckboxGroup,
  poi: RadioGroup, // Exp 28074: LS_Top_Attractions_Filter_by_Popularity
  popularFilter: PopularFilter, //Exp 28592: PWA_Contextual_Top_Filters
  guestRating: RadioGroup,
  accessibility: CheckboxGroup, //Exp 30590: HSR_Accessibility_filters
  paymentType: CheckboxGroup,
  bedroomFilter: ButtonToggleGroupCheckbox, // Exp 31385: PWA_VR__Bedrooms_Filter_and_Playback_on_HSR
  propertyStyle: CheckboxGroup
};
